module.exports = __webpack_public_path__ + "img/img-b1087e.png";